import { gsap } from 'gsap';

export function fadeInit(el, translateY = 20) {
  gsap.set(el, { opacity: 0, translateY });
}

export function fadeEnter(el) {
  const tween = gsap.to(el, {
    opacity: 1,
    translateY: 0,
    duration: 1.5,
    ease: 'bloom',
  });

  return tween;
}

export function fadeLeave(el, translateY = 20) {
  el.removeAttribute('data-animated');
  const tween = gsap.to(el, {
    opacity: 0,
    translateY,
    ease: 'bloom',
  });

  return tween;
}
